export default "__VITE_ASSET__65357279__"